import { useState } from "react";
import { createInvoice } from "../api/invoices";
import { useNavigate } from "react-router-dom";

export default function InvoiceCreate() {
    const [form, setForm] = useState({
        number: "",
        orderId: "",
        amount: "",
        currency: "EUR",
        description: "",
        dueDate: "",
    });

    const [err, setErr] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    async function onSubmit(e) {
        e.preventDefault();
        setErr("");
        setLoading(true);

        try {
            await createInvoice({
                number: form.number.trim(),
                amount: Number(form.amount),
                currency: form.currency || "EUR",
                orderId: form.orderId ? Number(form.orderId) : undefined,
                description: form.description || undefined,
                dueDate: form.dueDate || undefined,
            });

            navigate("/invoices");
        } catch (e) {
            setErr(e.message || "Create failed");
        } finally {
            setLoading(false);
        }
    }

    return (
        <div className="max-w-md mx-auto p-6">
            <h2 className="text-lg font-bold mb-4">New Invoice</h2>

            {err && <p className="text-red-500 mb-2">{err}</p>}

            <form onSubmit={onSubmit} className="space-y-3">
                <input
                    className="border p-2 w-full"
                    placeholder="Number"
                    value={form.number}
                    onChange={(e) => setForm({ ...form, number: e.target.value })}
                    required
                />
                <input
                    className="border p-2 w-full"
                    placeholder="Order ID"
                    type="number"
                    value={form.orderId}
                    onChange={(e) =>
                        setForm({ ...form, orderId: e.target.value })
                    }
                />
                <input
                    className="border p-2 w-full"
                    placeholder="Amount"
                    type="number"
                    min="0"
                    step="0.01"
                    value={form.amount}
                    onChange={(e) => setForm({ ...form, amount: e.target.value })}
                    required
                />

                <input
                    className="border p-2 w-full"
                    placeholder="Currency (EUR)"
                    value={form.currency}
                    onChange={(e) => setForm({ ...form, currency: e.target.value })}
                />

                <input
                    className="border p-2 w-full"
                    type="date"
                    value={form.dueDate}
                    onChange={(e) => setForm({ ...form, dueDate: e.target.value })}
                />

                <textarea
                    className="border p-2 w-full"
                    placeholder="Description"
                    value={form.description}
                    onChange={(e) => setForm({ ...form, description: e.target.value })}
                />

                <button
                    disabled={loading}
                    className="bg-blue-600 text-white px-4 py-2 rounded"
                >
                    {loading ? "Saving�" : "Save"}
                </button>
            </form>
        </div>
    );
}